import Row from "./Row";

export default function PageHeader({ children, icon, rightChildren }) {
  return (
    <Row
      as="h2"
      className="pt-10 pb-6 justify-between text-gray-500 min-h-[7rem]"
    >
      <Row>
        {icon}
        <span className="text-2xl">{children}</span>
      </Row>
      {rightChildren}
    </Row>
  );
}
